import React, { createContext, useContext, useEffect, useMemo } from 'react';
import { Head } from 'vite-react-ssg';
import { SITE_LOCALE, type Locale } from './locale';

interface LocaleContextValue { locale: Locale; formatLocale: 'en-US' | 'pt-BR' }
const LocaleContext = createContext<LocaleContextValue>({ locale: 'en', formatLocale: 'en-US' });

export function LocaleProvider({ children }: { children: React.ReactNode }) {
  // One language per build (and per domain), so it never changes while the app runs.
  const locale = SITE_LOCALE;
  const value = useMemo<LocaleContextValue>(() => ({ locale, formatLocale: locale === 'en' ? 'en-US' : 'pt-BR' }), [locale]);
  useEffect(() => {
    document.documentElement.dataset.hydrated = 'true';
    return () => { delete document.documentElement.dataset.hydrated; };
  }, []);
  return <LocaleContext.Provider value={value}>
    <Head htmlAttributes={{ lang: locale }}>{null}</Head>
    {children}
  </LocaleContext.Provider>;
}

export const useLocale = () => useContext(LocaleContext);
export function useMessages<T>(catalog: { en: T; 'pt-BR': T }): T {
  return catalog[useLocale().locale];
}
